import { ComponentProps, useCallback } from 'react'

import { DrawerBackdrop, DrawerContent, DrawerRoot } from '@/components/ui/drawer'
import { HEADER_HEIGHT } from '@/constants'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IDrawerDialogProps } from '@/types/gigiChat/DrawerDialogProps'

const DrawerDialog = ({ isOpen, onClose, size = 'sm', children, noPadding }: IDrawerDialogProps) => {
    const onOpenChange = useCallback<NonNullable<ComponentProps<typeof DrawerRoot>['onOpenChange']>>(
        (details) => {
            if (!details.open) {
                onClose?.()
            }
        },
        [onClose],
    )

    return (
        <DrawerRoot open={isOpen} placement="end" size={size} onOpenChange={onOpenChange}>
            <DrawerBackdrop
                mt={[HEADER_HEIGHT.mobile, HEADER_HEIGHT.mobile, HEADER_HEIGHT.desktop]}
                bg={useColorModeValue('white/80', 'black/80')}
            />
            <DrawerContent
                bg={useColorModeValue('white', 'dark.800')}
                mt={[HEADER_HEIGHT.mobile, HEADER_HEIGHT.mobile, HEADER_HEIGHT.desktop]}
                px={noPadding ? '0px' : '24px'}
                boxShadow="0px 4px 10px 1px rgba(84, 79, 64, 0.14);"
            >
                {children}
            </DrawerContent>
        </DrawerRoot>
    )
}

export default DrawerDialog
